/**
 * @file Utilities for working with API DTO dates.
 */

import dayjs from 'dayjs';

import { Durations } from '../constants';

export const createDuration = (duration = 0, unit = '') =>
  [Durations.YEARS, Durations.WEEKS, Durations.DAYS].includes(unit)
    ? `P${duration}${unit.toUpperCase()}`
    : `PT${duration}${unit.toUpperCase()}`;

export const parseDuration = (string = '') => {
  const duration = dayjs.duration(string);
  if (!string || !dayjs.isDuration(duration)) {
    return [0];
  }
  const unit = string.at(-1).toLowerCase();
  return [duration.as(unit), unit];
};
